import React from 'react';

const colors = {
  black: '#000000',
  gray2: '#e0e0e0',
};

const PrivacyPolicyScreen = () => {
  const handleBack = () => {
    window.history.back(); // Ou utilise useNavigate() si tu es avec React Router
  };

  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', padding: '20px' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '30px',
        flexDirection: 'row',
        marginTop: '10px',
        marginBottom: '10px',
      }}>
        <button
          onClick={handleBack}
          style={{
            width: '50px',
            height: '50px',
            borderRadius: '300px',
            backgroundColor: colors.gray2,
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }}
        >
          <span style={{ fontSize: '30px', position: 'relative', top: '0' }}>←</span>
        </button>

        <h2 style={{ fontSize: '22px', fontFamily: 'Inter, sans-serif', fontWeight: 700, color: colors.black }}>
          Politique de Confidentialité
        </h2>
      </div>

      <div style={{ fontSize: '16px', fontFamily: 'Inter, sans-serif', color: colors.black }}>
        <p style={{ marginBottom: '15px' }}>
          Nous prenons votre vie privée très au sérieux. Cette Politique de Confidentialité décrit comment nous recueillons, utilisons et protégeons vos informations personnelles lorsque vous utilisez notre application de mise en relation entre chauffeurs et clients.
        </p>

        <p style={{ marginBottom: '15px' }}>
          <strong>1. Collecte d'informations</strong> : Nous collectons des informations lorsque vous vous inscrivez, utilisez notre service ou interagissez avec nous. Cela peut inclure des informations personnelles telles que votre nom, adresse email, numéro de téléphone, contacts, photo, vidéo, audio et des données de localisation pour faciliter la mise en relation avec des passagers ou chauffeurs.
        </p>

        <p style={{ marginBottom: '15px' }}>
          <strong>2. Utilisation des informations</strong> : Vos informations peuvent être utilisées pour améliorer nos services, vous contacter, gérer votre compte, et vous envoyer des notifications importantes. Nous pouvons également utiliser vos informations pour analyser l'utilisation de notre service et améliorer l'expérience utilisateur.
        </p>

        <p style={{ marginBottom: '15px' }}>
          <strong>3. Protection des données</strong> : Nous mettons en œuvre des mesures de sécurité pour protéger vos informations personnelles contre toute utilisation non autorisée. Cela inclut l'utilisation de protocoles de chiffrement côté serveur pour la transmission de données sensibles. Nous vous recommandons également de protéger vos informations d'identification en utilisant des mots de passe forts et en les changeant régulièrement.
        </p>

        <p style={{ marginBottom: '15px' }}>
          <strong>4. Partage d'informations</strong> : Nous ne partageons pas vos informations personnelles avec des tiers sans votre consentement, sauf si cela est requis par la loi ou pour protéger nos droits. Si nous partageons vos informations avec des partenaires pour fournir nos services, nous exigeons qu'ils protègent vos données de manière appropriée.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyScreen;